"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var atoms_1 = require("../../styles/atoms");
var selectors_1 = require("../selectors");
var Advantages = function () {
    var advantages = (0, react_redux_1.useSelector)(selectors_1.advantagesSelector);
    return (react_1.default.createElement(atoms_1.Div, { visible: !!advantages.length, className: "advantages" }, advantages.map(function (advantage, i) { return (react_1.default.createElement("div", { key: i, className: "col-xs-12 col-sm-4 advantages__item" },
        react_1.default.createElement("div", { className: "advantage" },
            react_1.default.createElement("h2", { dangerouslySetInnerHTML: {
                    __html: advantage.head,
                }, className: "advantage__title" }),
            react_1.default.createElement("div", { className: "advantage__description" }, advantage.body)))); })));
};
exports.default = Advantages;
